import styled from 'styled-components';

import {
  scale040,
  scale080,
  scale130,
  scale150,
  scale160,
  scale190,
  scale400,
} from '@xingternal/tokens';

import { Hero as XingternalHero } from '@xingternal/typography';
import { Button as XingternalButton } from '@xingternal/button';

import { mediaConfined, mediaSmallOrTiny } from '@xingternal/layout-tokens';
import {
  sectionInnerContainerMixin,
  sectionMixin,
} from '../../variables.style';

import InternalPicture from '../../Picture/Picture';

export const Container = styled.div`
  ${sectionMixin};
  margin-top: ${scale160};
  overflow: hidden;

  @media ${mediaConfined} {
    margin-top: ${scale150};
  }
`;
export const InnerContainer = styled.div`
  ${sectionInnerContainerMixin};
  padding-bottom: ${scale160};
  display: flex;

  @media ${mediaConfined} {
    padding-bottom: ${scale080};
  }
`;

export const Content = styled.div`
  @media ${mediaConfined} {
    width: 50%;
    flex: 1 0 auto;
    margin-right: ${scale190};
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const Picture = styled(InternalPicture)`
  width: 70%;
  margin-right: -20%;
  flex: 0 1 auto;

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const Hero = styled(XingternalHero)`
  margin-bottom: ${scale040};
  @media ${mediaConfined} {
    margin-bottom: ${scale080};
  }
`;

export const ButtonsSection = styled.div`
  margin-top: ${scale160};
  @media ${mediaConfined} {
    margin-top: ${scale130};
    max-width: ${scale400};
  }
`;

export const Button = styled(XingternalButton)`
  width: 100%;
  &:nth-child(1) {
    margin-bottom: ${scale040};
  }
`;
